/**
 * Separator — Visual divider line between groups of content.
 *
 * Separator Component Guidelines
 * - Use to visually divide sections in custom layouts. Menu, Combobox, and
 *   FieldGroup already have their own separator sub-components — use those instead
 *   of standalone Separator inside those contexts.
 * - Defaults to `orientation="horizontal"`. Use `orientation="vertical"` for
 *   side-by-side layouts (e.g. between toolbar sections).
 * @see https://base-ui.com/react/components/separator Base UI Separator documentation
 * @see https://ui.shadcn.com/docs/components/separator shadcn/ui Separator documentation
 */
import React from "react";

import { Separator as SeparatorPrimitive } from "@base-ui/react/separator";
import { cn } from "@replohq/lattice/utils/cn";

function Separator({
  className,
  orientation = "horizontal",
  ...props
}: SeparatorPrimitive.Props) {
  return (
    <SeparatorPrimitive
      data-slot="separator"
      orientation={orientation}
      className={cn(
        "bg-border shrink-0 data-[orientation=horizontal]:h-[0.5px] data-[orientation=horizontal]:w-full data-[orientation=vertical]:w-[0.5px] data-[orientation=vertical]:self-stretch",
        // Legacy cast - may or may not be necessary
        // eslint-disable-next-line replo/no-as-cast
        className as string,
      )}
      {...props}
    />
  );
}

export { Separator };
